export default "__VITE_ASSET__Cg4DOuou__"